/**
 * @file コンポーネント：フル動画ページスレッドポップアップ詳細ページ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledCommentContents = styled.div``;

export const StyledCommentContentsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    ${mediaQuery.sp(`
        flex-direction: column;
        align-items: flex-end;
    `)};

    ${mediaQuery.spWide(`
        flex-direction: column;
        align-items: flex-end;
    `)};

    ${mediaQuery.tablet(`
        flex-direction: column;
        align-items: flex-end;
    `)};
`;

export const StyledCommentContentsHeaderText = styled.h3`
    color: #000000;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;

    ${mediaQuery.sp(`
        align-self: flex-start;
        margin-bottom: 16px;
    `)};

    ${mediaQuery.spWide(`
        align-self: flex-start;
        margin-bottom: 16px;
    `)};

    ${mediaQuery.tablet(`
        align-self: flex-start;
        margin-bottom: 16px;
    `)};
`;

export const StyledContainer = styled.div`
    margin-bottom: 175px;
    height: calc(100% - 175px);
    overflow-y: auto;

    ${mediaQuery.sp(`
        margin-bottom: 0;
        height: auto;
    `)};

    ${mediaQuery.spWide(`
        margin-bottom: 0;
        height: auto;
    `)};

    ${mediaQuery.tablet(`
        margin-bottom: 0;
        height: auto;
    `)};
`;

export const StyledNavigation = styled.ul`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
`;

export const StyledCommentList = styled.ul`
    margin: 16px 0;
`;

export const StyledCommentListItem = styled.li`
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledCommentNew = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 175px;
    padding-top: 24px;
    background-color: #ffffff;

    ${mediaQuery.sp(`
        position: initial;
        height: auto;
    `)};

    ${mediaQuery.spWide(`
        position: initial;
        height: auto;
    `)};

    ${mediaQuery.tablet(`
        position: initial;
        height: auto;
    `)};
`;

export const StyledCommentNewButtonlist = styled.ul`
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
`;

export const StyledCommentNewButtonlistItem = styled.li`
    margin-right: 16px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledCommentNewTextarea = styled.div`
    margin-bottom: 16px;
    height: 106px;
`;

export const StyledSelectContainer = styled.div``;

export const StyledThreadContent = styled.div`
    margin-bottom: 24px;
`;
